import {Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import moment from 'moment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import QueryParamsModel from 'src/app/services/queryParams.model';
import QPTypeModel from 'src/app/services/qpType.model';
import TestCategoryModel from 'src/app/services/testCategory.model';
import { BatchLoader } from 'src/app/Utils/batch-loader.util';
import { QPTypeService } from 'src/app/services/qp-type.service';
import { QueryParamsService } from 'src/app/services/query-params.service';
import { TestCategoryService } from 'src/app/services/test-category.service';

declare let $: any;
@Component({
  selector: 'app-quality-parameters',
  templateUrl: './quality-parameters.component.html',
  styleUrls: ['./quality-parameters.component.scss']
})
export class QualityParametersComponent implements OnInit, OnDestroy {
  public queryParams: QueryParamsModel[] = [];
  public queryParamsList: QueryParamsModel[] = [];
  public queryParam: QueryParamsModel = new QueryParamsModel();
  public filteredQueryParam: QueryParamsModel[] = [];
  public testCategories: Array<TestCategoryModel>;
  public testCategory: TestCategoryModel;
  public qpTypes: Array<QPTypeModel>;
  public qpType: QPTypeModel;
  public search: string;
  disabled = true;
  public submitButton: boolean;
  public updateButton: boolean;
  public queryParamsDoubleClick: boolean;
  public NoDataMessage: boolean = false;
  public clearSearchInput: boolean = false;
  public registerForm: FormGroup;
  public submitted = false;
  public enableDisablePageLoader: boolean = false;
  public listLoader = false;              // Show listLoader spinner
  public startIndex = 0;             // Tracks how much has been loaded
  public isFiltering: boolean = false;
  public noList: boolean = false;
  searchTimeout: any;
  public formFieldCount: number = 0;
  public showForm: boolean = false;

  constructor(private toastrService: ToastrService, public formBuilder: FormBuilder, public queryParamsService: QueryParamsService, public testCategoryService: TestCategoryService,
              public qpTypeService: QPTypeService, private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService) {
    this.queryParam = new QueryParamsModel();
    this.registerForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20), Validators.pattern('^[a-zA-Z ]*$')]],
      abbreviation: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('^[a-zA-Z0-9]*$')]],
      description: ['', [Validators.required, Validators.maxLength(200)]],
      uom: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(10)]],
      unit_code: ['', [Validators.required, Validators.minLength(3) ,Validators.maxLength(10), Validators.pattern('^[a-zA-Z0-9]*$')]],
      qp_type_id : ['', [Validators.required]],
      test_category_id : ['', [Validators.required]],
      is_derived: [null],
    });
    // Calculate field count after form is built // new
    this.formFieldCount = Object.keys(this.registerForm.controls).length;
  }

  private batchLoader: BatchLoader<any>;

  public async ngOnInit() {
    // this.pgLoad = false;
    window.scrollTo(0, 0);
    this.enableDisablePageLoader = true;
    this.clear();
    this.queryParams = [];
    this.queryParamsList = [];
    this.filteredQueryParam = [];
    this.isFiltering = false;
    this.search = '';
    this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
    try {
      this.testCategories = await this.testCategoryService.getAllTestCategory();
      this.qpTypes = await this.qpTypeService.getAllQpTypes();
      await this.getQueryParams();
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
    }
    this.queryParam.qp_type_id = undefined;
  }

  get f() {
    return this.registerForm.controls;
  }

  public async getQueryParams() {
    try {
      this.queryParams = await this.queryParamsService.getAllQueryParam();
      if (this.queryParams.length > 0) {
        this.queryParams.forEach(eachQueryParam => {
          this.qpType = this.getQPTypeById(String(eachQueryParam.qp_type_id));
          eachQueryParam.qpType = this.qpType;
          this.testCategory = this.getTestCategoryById(String(eachQueryParam.test_category_id));
          eachQueryParam.testCategory = this.testCategory;
        });
      }
      this.initializeBatchLoader(); // Reset instance
      this.batchLoader?.reset();     // Clear state
      await this.batchLoader?.loadNextBatch(true); // Load first batch
      this.enableDisablePageLoader = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.enableDisablePageLoader = false;
    }
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    this.checkScrollAndLoad();
  }

  private scrollTimeout: any;
  private checkScrollAndLoad(): void {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 50 && !this.batchLoader.isLoading()) {
        this.batchLoader.loadNextBatch();
      }
    }, 100);
  }

  private initializeBatchLoader(): void {
    this.batchLoader = new BatchLoader<any>(
      () => this.isFiltering ? this.filteredQueryParam : this.queryParams,
      (updatedList) => {
        this.queryParamsList = updatedList;
        this.noList = updatedList.length === 0;
      },
      undefined, // <-- omit or pass undefined
      (loading) => this.listLoader = loading
    );
    console.log('144', this.queryParamsList)
  }

  //To cancel ongoing requests and unsubscribe from subscriptions.
  public ngOnDestroy(): void {
    this.queryParamsService.cancelOnGoingHttpRequests();
    this.testCategoryService.cancelOnGoingHttpRequests();
    this.qpTypeService.cancelOnGoingHttpRequests();
    this.batchLoader?.markAsDestroyed();
    this.batchLoader.reset();
  }

  // search functionality
  public async applySearch(): Promise<void> {
    const query = this.search?.trim().toLowerCase() || '';
    this.isFiltering = query.length > 0;
    const sourceList = this.isFiltering
      ? this.queryParams.filter(qp =>
        qp.name?.toLowerCase().includes(query)
      )
      : this.queryParams;
    this.filteredQueryParam = this.isFiltering ? sourceList : [];
    this.batchLoader?.reset(true);
    await this.batchLoader?.loadNextBatch(true);
    if (sourceList.length === 0) {
      //  Force noList = true if nothing to show
      this.noList = true;
      this.queryParamsList = [];
      return;
    }
    // optional: handle scroll if user already at bottom
    setTimeout(() => this.checkScrollAndLoad(), 100);
  }

  public onSearchChanged(): void {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.applySearch(); // debounced
    }, 300);
  }

  public clear() {
    this.showForm = false;
    this.registerForm.reset();
    this.queryParam = new QueryParamsModel();
    this.submitButton = false;
    this.updateButton = false;
    this.queryParamsDoubleClick = false;
    this.submitted = false;
  }

  /*Add qp*/
  public async addUpdateQueryParams() {
    this.disabled = false;
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    try {
      this.queryParamsDoubleClick = true;
      // GET FORM VALUES
      const formData = this.registerForm.value; // contains updated values
      formData.created_name = localStorage.getItem('LoginUserName');
      formData.updated_name = localStorage.getItem('LoginUserName');
      if (this.submitButton) {
        await this.queryParamsService.create(formData);
        this.toastrService.success('Quality parameter created successfully', '', {
          timeOut: 3000
        });
      } else {
        const updateQueryParam = {...formData}
        delete updateQueryParam.id;
        await this.queryParamsService.updateOneByID(this.queryParam.id, updateQueryParam);
        this.toastrService.success('Quality parameter updated successfully', '', {
          timeOut: 3000
        });
      }
      await this.ngOnInit();
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.queryParamsDoubleClick = false;
    }
  }

  /*Get query params by id*/
  public async getQueryParamsById(id: string) {
    this.showForm = true;
    this.submitButton = false;
    this.updateButton = true;
    this.queryParamsDoubleClick = false;
    const foundQueryParams = this.queryParamsList.find(uom => uom?.id === id);
    this.queryParam = foundQueryParams ? { ...foundQueryParams } : new QueryParamsModel(); // clone object
    if (this.queryParam) {
      this.registerForm.patchValue({
        name: this.queryParam.name,
        abbreviation: this.queryParam.abbreviation,
        description: this.queryParam.description,
        uom: this.queryParam.uom,
        unit_code: this.queryParam.unit_code,
        qp_type_id: this.queryParam.qp_type_id,
        test_category_id: this.queryParam.test_category_id,
        is_derived: this.queryParam.is_derived,
      });
    }
  }

  /*Get qpType by id*/
  public getQPTypeById(id: string) {
    this.qpType = this.qpTypes.find(qpType => qpType && qpType.id == id);
    return this.qpType;
  }

  /*Get testCategory by id*/
  public getTestCategoryById(id: string) {
    this.testCategory = this.testCategories.find(testCategory => testCategory && testCategory.id == id);
    return this.testCategory;
  }

  public openForm() {
    this.showForm = true;
    this.submitButton = true;
    this.updateButton = false;
    // Count form fields to toggle layout
    this.formFieldCount = Object.keys(this.registerForm.controls).length;
  }
}
